<template>
  <div class="toast" v-if="visible">
    {{text}}
  </div>
</template>
<script>
  export default {
    name: 'toast',
    data() {
      return {
        visible: false,
        text: null,
        timer: null
      }
    },
    mounted() {
      this.timer = setTimeout(() => {
        this.close()
      }, 2000)
    },
    methods: {
      close() {
        clearTimeout(this.timer)
        this.visible = false
      }
    }
  }
</script>
<style scoped>
  .toast {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: .2rem .3rem;
    background: rgba(0, 0, 0, .7);
    color: #ffffff;
    border-radius: .05rem;
    transition: toast 1s ease-in;
    font-size: .3rem;
  }

  @keyframes toast {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
</style>



// WEBPACK FOOTER //
// toast.vue?52529cf8